import { Tabs } from "@asayinc/component-library";
import { Box } from "@mui/material";
import {
  Outlet,
  useLocation,
  useMatch,
  useNavigate,
  useParams,
} from "react-router-dom";

import { BackLink } from "src/components/atoms/BackLink";
import { ErrorState } from "src/components/atoms/ErrorState";
import { PageContainer } from "src/components/containers/PageContainer/PageContainer";
import { EventPageHeader } from "src/components/molecules/EventPageHeader";
import { LoadingHeader } from "src/components/molecules/Loading/LoadingHeader";
import { NOBO_EVENT_TABS } from "src/constants/tabs";
import { useNoboEventQuery } from "src/store/noboEvent";

export function NoboEvent() {
  const navigate = useNavigate();
  const location = useLocation();
  const backLink = location.state?.backLink;
  const { id } = useParams() as { id: string };
  const { data: noboEvent, isLoading, error } = useNoboEventQuery({ id });
  const match = useMatch(`/nobo-events/${id}/:activeTab`) as {
    params: { activeTab: string };
  };

  const handleTabChange = (value: string) => {
    navigate(`/nobo-events/${id}/${value}`);
  };

  if (error || (!isLoading && !noboEvent)) {
    return <ErrorState />;
  }

  return (
    <PageContainer>
      <BackLink
        sx={{ mb: 3, ml: -2, pt: 10, px: 10 }}
        label="Nobo Events"
        to={backLink || "/nobo-events"}
      />
      {isLoading ? (
        <LoadingHeader sx={{ px: 10 }} numberOfRows={1} />
      ) : (
        <EventPageHeader
          backLink={`/nobo-events/${id}/details`}
          issuerName={noboEvent.issuer.name || "-"}
          issuerId={noboEvent.issuer?.id}
          type="Nobo Event"
          subHeader={
            noboEvent.jobNumber
              ? `${noboEvent.solicitor.name} - ${noboEvent.jobNumber}`
              : noboEvent.solicitor.name
          }
          sx={{ px: 10 }}
        />
      )}
      <Box sx={{ mx: 10, mt: 3 }}>
        <Tabs
          activeTab={match?.params?.activeTab || "details"}
          clickHandler={handleTabChange}
          tabs={NOBO_EVENT_TABS}
        />
      </Box>
      <Outlet />
    </PageContainer>
  );
}
